module.exports = __webpack_public_path__ + "static/media/tab-media.7cc96cc9.svg";